export default __webpack_public_path__ + "static/media/cold-latte.fa6ad0f2.png";